import React, { FC, HTMLAttributes } from "react";
import { Images } from "../../../@assets/images";
import { ElBanner, elCarousol, elCarousolBox, ElContent, elGapBanner, elGapTitle, ElDetails, ElBannerImageInfinite, ElBannerImageCircle, ElImgBox, ElImgBoxImage } from "./timeline.css";
import { Container } from "../../layout";
import { elFlex, elFlexJustifyStart, elFlexNoWrap } from "../../../@css-style";
import { cx } from "@linaria/core";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import { ElHeadLine } from "../head-title";
interface ITimelineProps extends HTMLAttributes<HTMLElement> {
  image: string;
  details?: string[];
  title: string;
}

export const Timeline: FC<ITimelineProps> = ({ children, image = Images.design.timeLineCreate, title, details, ...props }) => {
  return (
    <ElBanner {...props}>
      <ElBannerImageInfinite src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/invitinte.png' />
      <ElBannerImageCircle src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/cicrcle.png' />
      <Container className={elGapBanner}>
        <ElContent className={cx(elFlexJustifyStart, elGapTitle)}>
          <ElHeadLine style={{ maxWidth: "300px", "--hashTag": `"#EXPLORE PROGRAM"` }}>{title}</ElHeadLine>
        </ElContent>
        <ElContent className={cx(elFlexNoWrap, elCarousolBox)}>
          <CarouselProvider className={elCarousol} naturalSlideHeight={0} visibleSlides={1} totalSlides={1} naturalSlideWidth={100} isIntrinsicHeight infinite={true}>
            <Slider>
              <Slide className={elFlex} index={0}>
                <ElImgBox>
                  <ElImgBoxImage src='https://storage.googleapis.com/bekup-ekraf-assets/images/new-design/time-line-create.png' />
                </ElImgBox>
              </Slide>
            </Slider>
          </CarouselProvider>
        </ElContent>
        {details && (
          <ElContent className={cx(elFlexJustifyStart, elGapTitle)}>
            <ElDetails></ElDetails>
            {details?.map((text, i) => (
              <ElDetails
                key={i}
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
              ></ElDetails>
            ))}
          </ElContent>
        )}
      </Container>
    </ElBanner>
  );
};
